var exports = {
  "kL": "FriendSelector.module__container___Q0psOH",
  "hJ": "FriendSelector.module__searchField___Q0psOH",
  "lA": "FriendSelector.module__searchFieldInner___Q0psOH",
  "t$": "FriendSelector.module__selectedPill___Q0psOH",
  "DT": "FriendSelector.module__removeButton___Q0psOH",
  "qc": "FriendSelector.module__searchIcon___Q0psOH",
  "D3": "FriendSelector.module__searchIconFocused___Q0psOH",
  "Rt": "FriendSelector.module__searchInput___Q0psOH",
  "XG": "FriendSelector.module__scroller___Q0psOH",
  "yY": "FriendSelector.module__scrollerNoSearch___Q0psOH",
  "p$": "FriendSelector.module__emptyState___Q0psOH",
  "q6": "FriendSelector.module__emptyStateText___Q0psOH",
  "_s": "FriendSelector.module__groupsContainer___Q0psOH",
  "cp": "FriendSelector.module__groupLetter___Q0psOH",
  "QS": "FriendSelector.module__friendsList___Q0psOH",
  "jZ": "FriendSelector.module__friendButton___Q0psOH",
  "An": "FriendSelector.module__friendButtonSelected___Q0psOH",
  "FI": "FriendSelector.module__friendButtonDisabled___Q0psOH",
  "Hb": "FriendSelector.module__friendInfo___Q0psOH",
  "G3": "FriendSelector.module__friendName___Q0psOH",
  "HI": "FriendSelector.module__checkboxContainer___Q0psOH",
  "Yz": "FriendSelector.module__removeIcon___Q0psOH",
};

module.exports = exports;
